import { apiGetAuth } from '@/utils/api'
import { API_MASTER_DATA } from '@/utils/api-url'

const state = {
  status_master_data_list: { data: [] },
  membership_status_list: { data: [] },
  sync_status_list: { data: [] },
  province_list: { data: [] },
  city_list: { data: [] },
  district_list: { data: [] },
  village_list: { data: [] }
}

const mutations = {
  "SET_STATUS_MASTER_DATA_LIST": (state, payload) => {
    state.status_master_data_list = payload
  },
  "SET_MEMBERSHIP_STATUS_LIST": (state, payload) => {
    state.membership_status_list = payload
  },
  "SET_SYNC_STATUS_LIST": (state, payload) => {
    state.sync_status_list = payload
  },
  "SET_PROVINCE_LIST": (state, payload) => {
    state.province_list = payload
  },
  "SET_CITY_LIST": (state, payload) => {
    state.city_list = payload
  },
  "SET_DISTRICT_LIST": (state, payload) => {
    state.district_list = payload
  },
  "SET_VILLAGE_LIST": (state, payload) => {
    state.village_list = payload
  }
}

const actions = {
  async getStatusMasterDataList(context, payload) {
    try {
      const response = await apiGetAuth(API_MASTER_DATA.LIST_STATUS, payload)
      context.commit('SET_STATUS_MASTER_DATA_LIST', response?.data)
    } catch (err) {
      return err
    }
  },
  async getMembershipStatusList(context, payload) {
    try {
      const response = await apiGetAuth(API_MASTER_DATA.LIST_STATUS, payload)
      context.commit('SET_MEMBERSHIP_STATUS_LIST', response?.data)
    } catch (err) {
      return err
    }
  },
  async getSyncStatusList(context, payload) {
    try {
      const response = await apiGetAuth(API_MASTER_DATA.LIST_STATUS, payload)
      context.commit('SET_SYNC_STATUS_LIST', response?.data)
    } catch (err) {
      return err
    }
  },
  async getProvinceList(context, payload) {
    try {
      const response = await apiGetAuth(API_MASTER_DATA.LIST_PROVINCE, payload)
      context.commit('SET_PROVINCE_LIST', response?.data)
    } catch (err) {
      return err
    }
  },
  async getCityList(context, payload) {
    try {
      const response = await apiGetAuth(API_MASTER_DATA.LIST_CITY, payload)
      context.commit('SET_CITY_LIST', response?.data)
    } catch (err) {
      return err
    }
  },
  async getDistrictList(context, payload) {
    try {
      const response = await apiGetAuth(API_MASTER_DATA.LIST_DISTRICT, payload)
      context.commit('SET_DISTRICT_LIST', response?.data)
    } catch (err) {
      return err
    }
  },
  async getVillageList(context, payload) {
    try {
      const response = await apiGetAuth(API_MASTER_DATA.LIST_VILLAGE, payload)
      context.commit('SET_VILLAGE_LIST', response?.data)
    } catch (err) {
      return err
    }
  }
}

const getters = {
  get_status_master_data_list: state => {
    return state.status_master_data_list
  },
  get_membership_status_list: state => {
    return state.membership_status_list
  },
  get_sync_status_list: state => {
    return state.sync_status_list
  },
  get_province_list: state => {
    return state.province_list
  },
  get_city_list: state => {
    return state.city_list
  },
  get_district_list: state => {
    return state.district_list
  },
  get_village_list: state => {
    return state.village_list
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
